// extracted by mini-css-extract-plugin
export default {"container":"GetRomp_container__6P3Vf","relative_container":"GetRomp_relative_container__Njcm3"};